import logger from './logger'
import createUnresolveablePromise from './createUnresolveablePromise.js'

/**
 * Redirects to login page
 */
export async function redirectToLogin() {
  window._REDIRECTING_TO_LOGIN_ = true

  const { getIsUnifiedShellEnabled } = await System.import(
    '@wf-mfe/unified-shell-bootstrapper'
  )

  if (getIsUnifiedShellEnabled()) {
    const user = await import('@adobe/exc-app/user')
    user.default.authExpired()

    return createUnresolveablePromise()
  }

  if (isInWorkfront()) {
    window.location.assign(
      `${window.location.origin}/qs/login?nextURL=${encodeURIComponent(
        `${window.location.pathname}${window.location.search}`
      )}`
    )

    return createUnresolveablePromise()
  }

  logger.warn('Workfront did not redirect to login')
}

export function shouldRedirectToLogin(response) {
  const notAuthorized = response.status === 401
  const mustLogin = response.redirected && response.url?.startsWith('/login')

  return notAuthorized || mustLogin
}

const workfrontHostNameRegex = /\.workfront(-dev)?\./
function isInWorkfront() {
  return window.location.hostname.match(workfrontHostNameRegex)
}
